import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import IQMForm from './components/IQMForm';
import {
  requestWorkroomList,
  createIQM,
  navigate,
  clearValidationErrors,
} from 'actionCreators';
import { getWorkroomList } from '../../../../reducers';
import ui from 'redux-ui';

class IQMNew extends Component {
  static propTypes = {
    clearValidationErrors: PropTypes.func.isRequired,
    createIQM: PropTypes.func.isRequired,
    requestWorkroomList: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    updateUI: PropTypes.func,
    errors: PropTypes.object,
    workrooms: PropTypes.array,
  }

  componentDidMount() {
    this.props.requestWorkroomList();
  }

  componentWillUnmount() {
    this.props.clearValidationErrors('IQM');
  }

  handleCancel = () => this.props.navigate('/iqms');

  handleSave = (iqm) => {
    this.props.createIQM(iqm)
      .then((res) => {
        this.props.navigate('/iqms');
        this.props.updateUI('successMessage', `${res.payload.name} was added.
          A confirmation email was sent to ${res.payload.email}. This email will expire in 7 days.`);
      });
  }

  render() {
    const { errors, workrooms } = this.props;
    return (
      <IQMForm
        errors={errors}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        workrooms={workrooms}
      />
    );
  }
}

const mapStateToProps = state => (
  {
    errors: state.iqms.common.errors,
    workrooms: getWorkroomList(state),
  }
);

export default ui()(connect(
  mapStateToProps,
  { requestWorkroomList, clearValidationErrors, createIQM, navigate },
)(IQMNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/IQMNew.jsx